/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Processing_Job_OfInputs */



/**
* | output |
* | --- |
* | "Processing job {completed} of {total}" |
*
* @param {Processing_Job_OfInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const processing_job_of = /** @type {((inputs: Processing_Job_OfInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Processing_Job_OfInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Traitement de la tâche ${i?.completed} sur ${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verarbeitungsauftrag ${i?.completed} von ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Elaborazione del lavoro ${i?.completed} di ${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обработка задания ${i?.completed} из ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Procesando el trabajo ${i?.completed} de ${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在处理 ${i?.total} 的 ${i?.completed} 作业`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ジョブ ${i?.completed} / ${i?.total} を処理中`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.total} के ${i?.completed} कार्य की प्रक्रिया चल रही है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Processando tarefa ${i?.completed} de ${i?.total}`)
	return /** @type {LocalizedString} */ (`Processing job ${i?.completed} of ${i?.total}`)
});